import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Obrigado";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/obrigado")({
  head: () => pageHead({ title: "Pagamento Confirmado | Clara Camille", path: "/obrigado", noindex: true }),
  validateSearch: (search: Record<string, unknown>): { email?: string } =>
    typeof search.email === "string" ? { email: search.email } : {},
  component: Page,
});
